/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */

import { PeriodicJobFormFields } from '../../../Shared/Constants/App';
import { VendorAssignmentAction, VendorType } from '../../../Shared/Utilities/utils';

export type VendorBidDetailsDto = {
  bidName?: string;
  vendorBidCost?: number;
  markupPCT?: number;
  vendorBidQuote?: number;
  mdFrequencyType?: string;
  isFlatMargin?: string;
  comments?: string;
  bidCreationDate?: Date;
  bidTemplate?: string;
  bidCreatedFromSample?: string;
  bidVersion?: number;
  bidVersionCreatedDate?: Date;
  bidEstimationType?: string;
  submittedBy?: string;
  bidSubmissionDate?: Date;
  draftStep?: string;
  draftStatus?: string;
  profitMarginAmount?: number;
  profitMarginPCT?: number;
};

export type JobVendorAssignmentInputDto = {
  jobId: string;
  workOrderId?: string;
  vendorId?: string;
  vendorEmail?: string;
  vendorName?: string;
  bidId?: string;
  vendorBidDetails?: VendorBidDetailsDto;
  jobDetails?: any;
  subJobId?: string;
};

export type VendorAssignmentDto = {
  existingVendorType: VendorType;
  updateVendorType: VendorType;
  action: VendorAssignmentAction;
  jobAssignments: JobVendorAssignmentInputDto[];
  effectiveStartDate?: string;
};
export type VmsJobSchedulesDto = {
  scheduleName: string;
  mdScheduleType: string;
  scheduleStartTime?: string;
  scheduleEndTime?: string;
  scheduleDays?: string;
  mdShiftType?: string;
  endDateOffset?: string;
  serviceCategoryId?: string[];
  associates?: string[];
  supervisors?: string[];
};

export interface IPeriodicJobPayload {
  jobNumber: string;
  jobType: string;
  jobStartDate: Date;
  vendorId: string;
  vendorEmail?: string;
  selfPerformed?: boolean;
  createdBy?: string;
  schedules?: VmsJobSchedulesDto[];
  customerId?: string;
}

export interface IPeriodicJobFormData {
  [PeriodicJobFormFields.JobNumber]: string;
  [PeriodicJobFormFields.FulfillmentType]: JobFulfillmentType;
  [PeriodicJobFormFields.Vendor]: string;
}

export interface ICreatePeriodicJobCard {
  open: boolean;
  onClose: () => void;
  isLoading?: boolean;
  selectedRows?: any[];
  handleVendorChange: (pickerMode?: boolean) => Promise<any> | void;
}

export enum JobFulfillmentType {
  SelfPerformed = 'Self-Performed',
  SubContracted = 'Sub-Contracted',
}
